// Chemins partagés entre plusieurs pages, quand le chemin porte une décision et
// pas seulement une adresse.

// Le registre s'ouvre avant de demander qui vous êtes.
//
// `/enregistrer` est une route publique, et la page a été construite pour un
// visiteur anonyme : elle lui laisse décrire sa montre, conserve son brouillon
// en sessionStorage pour qu'il survive au détour par Google, et ne demande la
// connexion qu'à l'étape qui téléverse des fichiers — c'est-à-dire quand la
// personne a déjà quelque chose à perdre.
//
// Sept pages dressaient pourtant un mur devant cette porte, en envoyant tout
// visiteur non connecté vers `/login?redirect=%2Fenregistrer`. Sur les vingt-
// deux personnes qui ont cliqué « enregistrer ma montre », dix ont atterri sur
// l'écran de connexion et la moitié d'entre elles l'ont quitté immédiatement.
//
// Aucun lien vers l'enregistrement ne doit donc passer par `/login` : le
// consentement à créer un compte se demande dans le formulaire, au moment où
// il est nécessaire, jamais avant de l'avoir montré.
export const REGISTER_PATH = "/enregistrer";

// Les adresses anglaises qu'on cite hors du site — un e-mail de prospection, un
// visuel, un document imprimé — n'existaient pas. Le site n'a qu'une URL
// canonique par page, en français, et le sélecteur de langue ne la change pas :
// c'est un bon choix, mais il laisse tomber sur la page d'erreur quiconque tape
// ce qu'on vient de lui écrire.
//
// Redirection, jamais page jumelle : l'adresse canonique reste unique, donc
// aucun contenu dupliqué à indexer.
//
// Seules celles qu'on cite réellement. Les mentions légales n'y sont pas :
// personne ne tape `/terms` de mémoire.
export const ROUTE_ALIASES = {
  "/register": REGISTER_PATH,
  "/gallery": "/galerie",
  "/stolen": "/montres-volees",
  "/report-theft": "/declarer-vol",
  "/pricing": "/tarifs",
  "/about": "/a-propos",
  "/passport": "/le-passeport",
  "/verify": "/verifier",
};
